
export default {
    namespaced: true,

    state: {
        cartId: localStorage.getItem('cart-id'),
        cart: null
    },

    getters: {
        get: (state) => () => {
            return state.cart;
        },

        count(state) {           
            if(!state.cart) {
                return 0;
            }

            let total = 0;
            for(let i of state.cart.items)
            {
                if (i.product.type === 'product') {
                    total += i.quantity;
                }
            }
            return total;
        },

        hasErrors: (state, getters, rootState, rootGetters) => {
            return state.cart.errors && state.cart.errors.length > 0;
        },

        getStock: (state) => (productId) => {
            for(let i of state.cart.stock) {
                if(i.product === productId) {
                    return i.stock;
                }
            }

            return 0;
        }
    },

    mutations: {
        set(state, { cart }) {
            state.cart = cart;

            if(cart) {
                state.cartId = cart.id;
                localStorage.setItem('cart-id', state.cartId);
            }
            else {
                state.cartId = null;
                localStorage.removeItem('cart-id');
            }
        }
    },

    actions: {
        async clear({ state, commit }) {
            commit('set', { cart: null });
        },

        async get({state, commit}) {
            if(state.cartId) {
                // TODO: since we allow anon users to fetch their carts, and since we are now stateless, we need to allow 
                // access with just an id... this could be easy to manipulate... maybe switch to uuids?
                try {
                    let result = await this._vm.$api.get('/api/carts/' + state.cartId);
                    commit('set', { cart: result });
                } 
                catch(err) {
                    // create new cart
                    let result = await this._vm.$api.post('/api/carts');
                    commit('set', { cart: result });    
                }
            }
            else {
                // create new cart
                let result = await this._vm.$api.post('/api/carts');
                commit('set', { cart: result });
            }
        },

        async add({ commit, state }, { item }) {
            let result = await this._vm.$api.cartAdd(state.cart.id, item.product, item.quantity);
            commit('set', { cart: result });
        },

        async remove({ commit, state }, { item }) {
            let result = await this._vm.$api.cartRemove(state.cart.id, item.product, item.quantity);
            commit('set', { cart: result });
        },

        async setCustomer({ commit, state }, { customer }) {
            let result = await this._vm.$api.cartPatch(state.cart.id, {
                customer: customer.id
            });

            commit('set', { cart: result });
        },

        async setShippingAddress({ commit, state }, { customer, address }) {
            let result = await this._vm.$api.cartPatch(state.cart.id, {
                customer: customer.id,
                shippingAddress: address.id
            });

            commit('set', { cart: result });
        },

        async setDeliverySchedule({ commit, state }, { schedule }) {
            let result = await this._vm.$api.cartPatch(state.cart.id, {
                schedule: schedule.id
            });
            
            commit('set', { cart: result });
        },

        async setBillingAddress({ commit, state }, { address }) {
            let result = await this._vm.$api.cartPatch(state.cart.id, {
                billingAddress: address.id
            });
            
            commit('set', { cart: result });
        }
    }
}